import { useLanguage } from "@/lib/i18n";
import { blogContent } from "./content";

export function BlogIntro() {
  const { language } = useLanguage();
  const c = blogContent[language].intro;

  return (
    <section className="mx-auto max-w-[680px] px-4 sm:px-6 pt-10 pb-12">
      <div className="prose-blog space-y-6">
        <p className="font-['Source_Serif_4'] text-[1.0625rem] sm:text-lg leading-[1.75] text-foreground/85 first-letter:font-['Source_Serif_4'] first-letter:text-[3.75rem] first-letter:leading-[0.85] first-letter:font-bold first-letter:float-left first-letter:mr-3 first-letter:mt-1.5 first-letter:text-primary">
          {c.p1Start}
          <span className="font-mono text-[0.85em] text-primary/90 bg-primary/[0.08] px-1.5 py-0.5 rounded">
            MERCH SKU 847291
          </span>
          {c.p1End}
        </p>

        <p className="font-['Source_Serif_4'] text-[1.0625rem] sm:text-lg leading-[1.75] text-foreground/85">
          {c.p2Start}
          <strong className="text-foreground font-semibold">{c.p2Strong}</strong>
          {c.p2End}
        </p>

        <blockquote className="border-l-2 border-primary pl-5 sm:pl-6 py-1 my-8">
          <p className="font-['Source_Serif_4'] text-xl sm:text-2xl leading-snug text-foreground italic font-medium">
            {c.quote}
          </p>
        </blockquote>

        <p className="font-['Source_Serif_4'] text-[1.0625rem] sm:text-lg leading-[1.75] text-foreground/85">
          {c.p3}
        </p>
      </div>
    </section>
  );
}
